import classNames from 'classnames';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import Dropzone from 'react-dropzone';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './UploadFileInput.less';
import {TranslateUtils} from 'src/js/common/utils';
import {intlShape} from 'src/js/common/utils/translate_utils';

const I18N = defineMessages({
  UPLOAD: {
    id: 'upload.input.title',
    defaultMessage: 'Upload files',
    description: 'title text for upload input',
  },
});

class UploadFileInput extends React.PureComponent {
  constructor() {
    super();
    this.handleDrop = this.handleDrop.bind(this);
  }

  handleDrop(acceptedFiles, fileRejections) {
    const {handleUpload} = this.props;
    if (handleUpload) {
      handleUpload(acceptedFiles, fileRejections);
    }
  }

  /* eslint-disable react/no-array-index-key, no-nested-ternary */
  render() {
    const {
      intl,
      isUploadingCounter,
      isUploadSuccessful,
      maxSize,
      uploadedFiles,
    } = this.props;
    return (
      <div className={styles.dlUploadFileInput}>
        <Dropzone
          onDrop={this.handleDrop}
          maxSize={maxSize}
          tabIndex={0}
          className={styles.dlUploadFileDropzone}
          title={TranslateUtils.translate(I18N.UPLOAD, intl)}
        >
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <i className={'fas fa-upload fa-2x'} />
            </div>
          )}
        </Dropzone>
        {isEmpty(uploadedFiles)
          ? null
          : uploadedFiles.map((item, idx) => (
              <div
                key={idx}
                className={classNames({
                  [styles.dlUploadedFile]: true,
                  [styles.dlUploadedFileSuccess]:
                    isUploadingCounter === 0 && isUploadSuccessful,
                  [styles.dlUploadedFileFailure]:
                    isUploadingCounter === 0 && !isUploadSuccessful,
                })}
              >
                <span className={styles.dlUploadedFileName}>{item}</span>
                {isUploadingCounter > 0 ? (
                  <i className={'fas fa-spinner fa-pulse'} />
                ) : isUploadSuccessful ? (
                  <i className={'fas fa-check'} />
                ) : (
                  <i className={'fas fa-exclamation'} />
                )}
              </div>
            ))}
      </div>
    );
  }

  /* eslint-enable react/no-array-index-key, no-nested-ternary */
}

UploadFileInput.displayName = 'UploadFileInput';

UploadFileInput.propTypes = {
  handleUpload: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  maxSize: PropTypes.number,
  isUploadingCounter: PropTypes.number.isRequired,
  isUploadSuccessful: PropTypes.bool.isRequired,
  uploadedFiles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

UploadFileInput.defaultProps = {
  maxSize: Infinity,
};

export default injectIntl(UploadFileInput);
